<template>
    <div class="answer-column-wrapper">
        <div
            class="answer-data"
            :class="{ 'show-hidden': showHideStyle, 'single-text': !showHideStyle }"
            ref="answerText"
            @mousemove="moveHandle"
            @mouseout="outHandle"
        >
            <span class="text">{{ answerTxt }}</span>
        </div>
        <div class="hover-answer" v-show="showDetail && showHideStyle">{{ answerTxt }}</div>
    </div>
</template>

<script>
export default {
    name: "AnswerColumn",
    props: ["data", "row"],
    data() {
        return {
            showDetail: false,
            lineHight: "",
            answerTxt: this.computedAnswerData()
        };
    },
    computed: {
        showHideStyle() {
            if (this.lineHight > 40) {
                return true;
            } else {
                return false;
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.lineHight = this.$refs.answerText.scrollHeight;
        });
    },
    methods: {
        moveHandle() {
            this.showDetail = true;
        },
        outHandle() {
            this.showDetail = false;
        },
        computedAnswerData() {
            if (this.data && this.data.toString().indexOf("[{") > -1) {
                let answerArr = JSON.parse(this.row.addData.answerDetail);
                let firstAnswerArr = "";
                for (let i = 0; i < answerArr.length; i++) {
                    firstAnswerArr = answerArr[0].answer;
                }
                let firstAnswerTxt = "";
                firstAnswerArr.some(item => {
                    if (item.type == "text") {
                        firstAnswerTxt = item.text;
                        return true;
                    }
                });

                return firstAnswerTxt;
            } else {
                return this.data;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.answer-column-wrapper {
    position: relative;

    .answer-data {
        cursor: pointer;
        height: 34px;
        line-height: 17px;
        align-items: center;
        padding-right: 8px;
        word-break: break-all;
        word-wrap: break-word;
        overflow: hidden;
        position: relative;
        .text{
            max-height: 34px;
        }
    }

    .single-text {
        display: flex;
    }

    .show-hidden {
        &:after {
            content: "...";
            width: 7px;
            position: absolute;
            top: 17px;
            right: 5px;
        }
    }

    .hover-answer {
        position: absolute;
        background: #fff;
        border-radius: 4px;
        padding: 5px 8px;
        top: auto;
        margin-top: 8px;
        width: 100%;
        text-align: center;
        white-space: normal;
        word-break: break-all;
        word-wrap: break-word;
        text-align: left;
        box-shadow: 0 0 8px 0 rgba(90, 98, 111, 0.25);
        z-index: 1;
    }
}
</style>
